import roContract from './languages/ro'
// import atContract from './languages/at'
import deContract from './languages/de'
import huContract from './languages/hu'

const contracts = {
  ro: roContract,
  de: deContract,  
  at: deContract,   
  hu: huContract   
}

export const createContractConfig = (country, contract, executantDetails, firmaMontajContract) => {
  const config = contracts[country]
  
  if (!config) {
    throw new Error(`Contract config for country '${country}' not found`)
  }
  
  return config.create(contract, executantDetails, firmaMontajContract)
}